















































































































































































































import { Component, Vue } from "vue-property-decorator";
import { clearFilter } from "@/utils/base";
import { PostLogin } from "@/request/common";
import Remember from "../remember.vue";
import { Md5 } from "ts-md5";
import { GetVersionList } from "@/request/version";
@Component({
  components: {
    Remember,
  },
})
export default class Login extends Vue {
  private cTab: any = "";
  private logoUrl: any = "/theme/logo2.png"; // 默认图标
  private type: any = "text";
  private ifRember: any = true;
  private visible: any = false;
  private window: any = window;
  private loginInfo: any = {
    用户名: "",
    密码: "",
    teacher: "",
  };

  private paws: any = [];
  private showPassword: any = false;
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private changeEye(val: any) {
    this.showPassword = val;
    if (val) {
      this.type = "text";
    } else {
      this.type = "password";
    }
  }
  private pawInput(e: any) {
    if (!this.showPassword) {
      this.type = "password";
    }
  }
  private focus() {
    if (localStorage.getItem("jxpaws")) {
      this.paws = JSON.parse(localStorage.getItem("jxpaws") || "");
    }
  }
  private update(e: any) {
    this.type = "password";
    this.loginInfo.teacher = e.teacher;
    this.loginInfo["用户名"] = e.name;
    this.loginInfo["密码"] = e.paw;
    this.visible = false;
  }
  private delPaw(e: any) {
    if (e.length == 0) {
      this.type = "text";
    }
    this.paws = JSON.parse(JSON.stringify(e));
  }
  private ifShow(type: any) {
    let result: any = false;
    const arr: any = this.systemInfo.GLOBAL_SYSTEM;
    const index: any = arr.findIndex((val: any) => {
      return val == type;
    });
    if (index != -1) {
      result = true;
    }
    return result;
  }
  /**
   * @description 登录
   */
  private async login() {
    if (this.cTab == "思维学生" || this.cTab == "实训学生") {
      if (!this.loginInfo["teacher"]) {
        this.$message.warning("请输入教师账号");
        return;
      }
    }
    if (!this.loginInfo["用户名"]) {
      this.$message.warning("请输入用户名");
      return;
    }
    if (!this.loginInfo["密码"]) {
      this.$message.warning("请输入密码");
      return;
    }
    if (this.systemInfo.SETTING["ifVerify"]) {
      const loading = this.$loading({
        lock: true,
        text: "权限验证中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const res = await window.electronMyAPI.checkVerify();
      console.log("返回结果");
      console.log(res);
      if (res !== "success") {
        loading.close();

        this.$confirm("授权文件检测失败，可能是未授权或授权文件丢失", "", {
          customClass: "commonConfirm",
          cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
          cancelButtonText: "我知道了",
          showConfirmButton: false,
        });
        return;
      } else {
        loading.close();
      }
    }
    const params: any = {
      account: this.loginInfo["用户名"],
      密码: this.loginInfo["密码"],
      类别: this.cTab,
    };
    if (this.cTab == "思维学生" || this.cTab == "实训学生") {
      params["教师账户"] = this.loginInfo.teacher;
      params["类别"] = "学生";
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    PostLogin(this, params, loading)
      .then(async (res: any) => {
        loading.close();
        const token = res.token;
        const user = res.user;
        this.$store.commit("updateToken", token);
        this.$store.commit("updateUser", user);
        if (this.ifRember) {
          // 如果没有存过则储存，如果已经储存过则更新
          if (this.paws.length === 0) {
            this.paws.push({
              teacher: this.loginInfo.teacher,
              name: this.loginInfo["用户名"],
              paw: this.loginInfo["密码"],
            });
          } else {
            let ifRepeat: any = false;
            let i: any = "";
            this.paws.forEach((ele: any, index: any) => {
              if (ele.name == this.loginInfo["用户名"]) {
                i = index;
                ifRepeat = true;
              }
            });
            if (ifRepeat) {
              this.paws.splice(i, 1);
            }
            this.paws.push({
              teacher: this.loginInfo.teacher,
              name: this.loginInfo["用户名"],
              paw: this.loginInfo["密码"],
            });
          }
        }
        localStorage.setItem("jxpaws", JSON.stringify(this.paws));
        if (this.systemInfo.SETTING.iFHasDevicePulse) {
          if (this.cTab == "实训学生" || this.cTab == "教师") {
            console.log("检查", "check_hand", "检查");
            const checkResult = await window.electronMyAPI.changePulse(
              "检查",
              "check_hand",
              "检查"
            );
            console.log(checkResult);
            const loadingCheck = this.$loading({
              lock: true,
              text: "设备检查中……",
              spinner: "el-icon-loading",
              customClass: "loadClass",
              background: "rgba(255, 255, 255, 0.7)",
            });
            if (checkResult) {
              this.$store.commit("updateIfExitMai", true);
              if (checkResult == "success") {
                loadingCheck.close();
                alert("设备运行正常");
                this.goPage();
              } else {
                loadingCheck.close();
                alert("设备不存在");
                this.goPage();
              }
            } else {
              loadingCheck.close();
              this.$confirm(
                "设备检测失败，可能是脉象手设备未开机或是未连接",
                "",
                {
                  customClass: "commonConfirm",
                  cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
                  cancelButtonText: "我知道了",
                  showConfirmButton: false,
                }
              );
            }
          } else {
            this.goPage();
          }
        } else {
          this.goPage();
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private goPage() {
    clearFilter();
    if (this.cTab == "实训学生") {
      this.$router.push("/main/shixun/study-folder");
      this.$store.commit("updateCurPro", "实训学生");
    } else if (this.cTab == "思维学生") {
      this.$router.push("/main/siwei/folder");
      this.$store.commit("updateCurPro", "思维学生");
    } else if (this.cTab == "教师") {
      this.$router.push("/main/teacher/home");
      this.$store.commit("updateCurPro", "教师");
    } else if (this.cTab == "admin") {
      this.$router.push("/main/manage/user");
      this.$store.commit("updateCurPro", "管理");
    }
  }
  private async mounted() {
    if (localStorage.getItem("jxpaws")) {
      this.paws = JSON.parse(localStorage.getItem("jxpaws") || "");
      if (this.paws.length > 0) {
        this.update(this.paws[this.paws.length - 1]);
      }
    }
    if (this.$store.state.systemInfo.GLOBAL_SYSTEM.length > 0) {
      this.cTab = this.$store.state.systemInfo.GLOBAL_SYSTEM[0];
    }
    
    if (this.systemInfo.SETTING && this.systemInfo.SETTING.ifDesktop) {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      let params: any = {
        params: {
          name: "实训系统",
        },
      };
      GetVersionList(this, params, loading).then((res: any) => {
        console.log(res);
        const version = this.systemInfo.VERSION;
        console.log("当前版本");
        console.log(version);
        if (
          res.items &&
          res.items.length > 0 &&
          res.items[0]["fields"] &&
          res.items[0]["fields"]["软件版本号"] &&
          res.items[0]["fields"]["软件版本号"].length > 0 &&
          res.items[0]["fields"]["软件版本号"][0].text
        ) {
          console.log("最新版本");
          const cVersion = res.items[0]["fields"]["软件版本号"][0].text;
          console.log(cVersion);
          if (cVersion && cVersion != version) {
            this.$confirm("有新版本，是否更新？", "", {
              customClass: "commonConfirm",
              confirmButtonClass: "iconfont icon-anniu4 confirmSure",
              cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
              cancelButtonText: "不更新",
              confirmButtonText: "更新",
              // showCancelButton: false,
              closeOnClickModal: false,
              // closeOnPressEscape: false,
            }).then(() => {
              const url = res.items[0]["fields"]["软件版本URL"].link;
              console.log(url);
              // 使用 Electron 的下载 API
              let downloadLoading = this.$loading({
                lock: true,
                text: "下载中，请稍候...",
                spinner: "el-icon-loading",
                customClass: "loadClass",
                background: "rgba(255, 255, 255, 0.7)",
              });
              window.electronMyAPI
                .downloadFile(url)
                .then((result: any) => {
                  downloadLoading.close();
                  if (result.success) {
                    this.$message.success("下载成功，正在打开...");
                    let openLoading = this.$loading({
                      lock: true,
                      text: "打开中，请稍候...",
                      spinner: "el-icon-loading",
                      customClass: "loadClass",
                      background: "rgba(255, 255, 255, 0.7)",
                    });
                    window.electronMyAPI
                      .openPath(result.path)
                      .then(() => {
                        openLoading.close();
                      })
                      .catch(() => {
                        openLoading.close();
                      });
                  } else {
                    this.$message.error("下载失败：" + result.message);
                  }
                })
                .catch((error: any) => {
                  downloadLoading.close();
                  this.$message.error("下载出错：" + error);
                });
            });
          }
        }
      });
    }
  }
}
